module.exports = __webpack_public_path__ + "img/first.848c602f.jpg";